'use strict';

Array.isArray || (Array.isArray = function (a) {
  return '' + a !== a && Object.prototype.toString.call(a) === '[object Array]';
});



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/polyfills/array.isarray.js
// module id = 287
// module chunks = 0